import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-box" }
const _hoisted_2 = {
  class: "gfu-hd gfu-hd--h1 _mb-4",
  "data-qa": "contact-form-title"
}
const _hoisted_3 = ["readonly"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  class: "gfu-field gfu-contact-form__actions",
  "data-qa": "contact-form-section:Captcha"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_back = _resolveComponent("contact-back")
  const _component_contact_current_group_header = _resolveComponent("contact-current-group-header")
  const _component_field = _resolveComponent("field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_contact_back, {
      class: "_mb-3",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('back')))
    }),
    _createVNode(_component_contact_current_group_header, _normalizeProps(_guardReactiveProps({ currentCategoryGroup: $props.currentCategoryGroup, currentProject: $props.currentProject })), null, 16 /* FULL_PROPS */),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.Contact.TopicsSectionHeader), 1 /* TEXT */),
    _createVNode(_component_field, {
      name: "model.email",
      "display-name": _ctx.Resources.Contact.FormEmailFieldLabel,
      "data-qa": "contact-form-message:Email"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("input", {
          ref: "emailInput",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.email) = $event)),
          class: _normalizeClass(["gfu-field__input", {'gfu-field__input--readonly': $options.isEmailReadOnly}]),
          name: "email",
          type: "email",
          readonly: $options.isEmailReadOnly,
          "data-qa": "text-field-input"
        }, null, 10 /* CLASS, PROPS */, _hoisted_3), [
          [_vModelText, _ctx.model.email]
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["display-name"]),
    _createVNode(_component_field, {
      "display-name": _ctx.Resources.Contact.FormSubjectFieldLabel
    }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          value: $options.messageSubject,
          class: "gfu-field__input gfu-field__input--readonly",
          type: "text",
          readonly: "readonly",
          "data-qa": "contact-form-message:Subject"
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["display-name"]),
    _createVNode(_component_field, {
      name: "model.message",
      "display-name": _ctx.Resources.Contact.FormMessageFieldLabel,
      "data-qa": "contact-form-message:Message"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("textarea", {
          ref: "messageInput",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.model.message) = $event)),
          class: "gfu-field__textarea",
          cols: "60",
          rows: "4"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.model.message]
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["display-name"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_base_button, {
        type: "submit",
        theme: "accent",
        width: "wide",
        enabled: _ctx.isInitialized,
        class: "gfu-contact-form__submit",
        onClick: $options.onSubmit,
        "data-qa": "contact-form-message-btn:Submit"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.FormSubmitButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ]),
    _createVNode(_component_contact_back, {
      class: "_mt-3",
      onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('back')))
    }),
    _createVNode(_component_progress_overlay, {
      sticky: true,
      visible: _ctx.isProcessing
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}